<template>

  <modalo
    title="Google (Gmail)"
    type="mini"
    @hideModal="hideModal()">
    <div class="mb-4">
      <a
        class="btn btn-primary btn-lg"
        :href="href">
        Connect
      </a>
    </div>
    <p><i>This app use and transfer of information received from Google APIs to any other app will adhere to <a target="_blank" href="https://developers.google.com/terms/api-services-user-data-policy#additional_requirements_for_specific_api_scopes">Google API Services User Data Policy</a>, including the Limited Use requirements.</i></p>
  </modalo>

</template>

<script>
import config from '@/config'
export default {
  name: 'TagForm',
  components: {
  },
  props: {
  },
  data () {
    return {
    }
  },
  computed: {
    href () {
      const callbackUrl = `${config.app_url}#/config/calendar-settings`
      return `${config.provider_url}connect/google-calendar?callback_url=${encodeURIComponent(callbackUrl)}`
    }
  },
  created () {
  },
  methods: {
    /*
    hideModal
    */
    hideModal () {
      this.$emit('hideModal')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ProfileCalendarSettings/GoogleForm.vue